import React, { useDebugValue, useState } from 'react';
import InputField from './InputField';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { passwordChangeSchema } from './MyAcount.ValidationSchema';
import { submitPasswordChangeError, clearPasswordChangeError, savePasswordChange} from '../Actions/MyAccount.action';
import { addFlashMessage } from '../Actions/FlashMessages.action';

const validatePassword = async(data) => {
    return await passwordChangeSchema.validate(data, { abortEarly: false })
}

const MyAccountChangePassword = () => {
    const dispatch = useDispatch();
    const { payload, errors } = useSelector(state => state.myAccountChangePassword);
    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmedPassword: '',
    });

    const handleFieldChange = (name, value) => {
        setFormData((currentForm) => ({
            ...currentForm,
            [name]: value,
        }));
    }

    const clearFormState = () => {
        setFormData({
            currentPassword: '',
            newPassword: '',
            confirmedPassword: '',
        });
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setIsEditing(false);
        clearFormState();
        dispatch(clearPasswordChangeError());
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch(clearPasswordChangeError());

        try {
            await validatePassword(formData);
            await dispatch(savePasswordChange(formData));
            setIsEditing(false);
            dispatch(addFlashMessage({ 
                messageText: translate('js.myaccount.settings.message.passwordchangesuccess'), 
                messageType: "Green", 
                dismissible: true, 
                timeToLive: 10 }))
            clearFormState();
        } catch (ex) {
            dispatch(submitPasswordChangeError(ex));
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <div className="my-account-settings__component password">
            <h2>{translate('js.myaccount.settings.heading.password')}</h2>
            <p dangerouslySetInnerHTML={ {__html: payload?.changePasswordText?.value} } />
            {!isEditing ? 
                (<button onClick={() => setIsEditing(true)} className="button">{translate('js.myaccount.settings.button.changepassword')}</button>)
            : 
                (<form onSubmit={handleSubmit}>
                    <InputField
                        id='currentPassword'
                        name='currentPassword'
                        type='password'
                        value={formData.currentPassword}
                        required={true}
                        label={translate('js.myaccount.settings.label.oldpassword')}
                        onChange={(value) => handleFieldChange('currentPassword', value)}
                        errors={errors}
                        containerCssClass='half-row'
                    />

                    <InputField
                        id='newPassword'
                        name='newPassword'
                        type='password'
                        value={formData.newPassword}
                        required={true}
                        label={translate('js.myaccount.settings.label.newpassword')}
                        onChange={(value) => handleFieldChange('newPassword', value)}
                        errors={errors}
                        tooltip={translate('js.general.tooltip.password')}
                    />

                    <InputField
                        id='confirmNewPassword'
                        name='confirmNewPassword'
                        type='password'
                        value={formData.confirmNewPassword}
                        required={true}
                        label={translate('js.myaccount.settings.label.confirmpassword')}
                        onChange={(value) => handleFieldChange('confirmNewPassword', value)}
                        errors={errors}
                        tooltip={translate('js.general.tooltip.password')}
                    />
                    <div className="password__buttons">
                        <button type="submit" className={`button button__primary  ${isSaving && 'loading'}`} disabled={isSaving}>
                            <span>{translate('js.myaccount.settings.button.savepassword')}</span>
                            <span className="spinner spinner--light spinner--small"></span>
                        </button> 
                        <button onClick={handleCancel} className="button button__outline" disabled={isSaving}>{translate('js.myaccount.settings.button.cancel')}</button>
                    </div>
                </form>)
            }
        </div>
    )
}

export default MyAccountChangePassword;